import { useNavigate } from 'react-router-dom';
import { Users, ClipboardCheck } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

export default function ExploitationPage() {
    const navigate = useNavigate();

    const cards = [
        {
            key: 'espace',
            title: 'Espace déménageurs',
            description: 'Accès dédié pour les équipes sur le terrain.',
            icon: Users,
            color: 'text-[#2e7cd6]',
            bg: 'bg-blue-50',
            border: 'border-blue-100',
            path: '/exploitation/espace-demenageurs',
        },
        {
            key: 'pointage',
            title: 'Pointage déménageurs',
            description: 'Suivi des heures et présences des équipes.',
            icon: ClipboardCheck,
            color: 'text-emerald-600',
            bg: 'bg-emerald-50',
            border: 'border-emerald-100',
            path: '/exploitation/pointage-demenageurs',
        },
    ];

    return (
        <div className="p-4 md:p-6 lg:p-8" data-testid="exploitation-page">
            <div className="mb-8">
                <h1 
                    className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                    data-testid="exploitation-title"
                >
                    Exploitation
                </h1>
                <p className="mt-1 text-slate-500">
                    Gestion opérationnelle des équipes sur le terrain
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {cards.map((c) => {
                    const Icon = c.icon;
                    return (
                        <Card
                            key={c.key}
                            className={`rounded-xl border ${c.border} shadow-sm cursor-pointer transition-all hover:shadow-md bg-white`}
                            onClick={() => navigate(c.path)}
                            data-testid={`exploitation-card-${c.key}`}
                        >
                            <CardContent className="p-5 flex items-start gap-4">
                                <div className={`w-11 h-11 rounded-lg ${c.bg} flex items-center justify-center shrink-0`}>
                                    <Icon size={22} className={c.color} strokeWidth={2} />
                                </div>
                                <div>
                                    <h3 className="text-base font-semibold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                                        {c.title}
                                    </h3>
                                    <p className="text-xs text-slate-500 mt-1 leading-relaxed">
                                        {c.description}
                                    </p>
                                </div>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
}
